function imagePreloadFn() {
	var directive = {
		bindToController: true,
		controller: function ImagePreloadController() {},
		controllerAs: 'vm',
		link: link,
		restrict: 'A',
		scope: {},
	};
	return directive;

	function link(scope, element) {
		element.addClass('img-preload');

		const img = element[0];

		function onLoadImg() {
			element.addClass('in');
		}

		// Handle cached or already-loaded images (including lazy-loaded)
		if (img.complete && img.naturalHeight !== 0) {
			onLoadImg();
		} else {
			element.bind('load', onLoadImg);
		}
	}
}
//
export default angular.module('mod.drt.imagePreload', []).directive('imagePreload', imagePreloadFn).name;
